














import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { RawLocation } from 'vue-router'
import BaseLayout from '@/layout/BaseLayout.vue'
import AppInput from '@/components/AppInput/AppInput.vue'
import Language from '@/components/Language/Language.vue'
import CenterFormPanel from '@/components/Common/CenterFormPanel.vue'
import { UserActionTypes } from '@/store/modules/users/actions'
import { RouteNames } from '@/router'
import { isDevelopHost } from '@/constants/enviroment'

import type { UserContact } from '@/models/users'

export default Vue.extend({
  components: {
    AppInput,
    Language,
    BaseLayout,
    CenterFormPanel,
  },
  data() {
    return {
      name: '',
      surname: '',
      phone: '',
      defaultName: '',
      defaultSurname: '',
      defaultPhone: '',
      isDevelopHost,
    }
  },
  methods: {
    ...mapActions([UserActionTypes.UpdateCurrentUser]),
    preparePayload(): UserContact {
      return {
        fname: this.name,
        lname: this.surname,
        phone: this.phone,
      } as UserContact
    },
    update(): void {
      const payload = this.preparePayload()
      this[UserActionTypes.UpdateCurrentUser](payload).then(() => {
        this.initFormDataAndDefaultValues(payload) // reinitialize form values and defaults
      })
    },
    initFormDataAndDefaultValues(userContact: UserContact): void {
      this.defaultName = this.name = userContact.fname
      this.defaultSurname = this.surname = userContact.lname
      this.defaultPhone = this.phone = userContact.phone ?? ''
    },
    handleChangePhoneNumber(event: InputEvent): void {
      const { data } = event
      const target = event.target as HTMLInputElement

      const newValue = data
        ? target.value.match(/^\+?[\d]{0,16}$/g)?.[0] ?? this.phone
        : target.value

      this.phone = target.value = newValue
    },
  },
  computed: {
    ...mapGetters(['getMe']),
    canUpdate(): boolean {
      let result =
        this.defaultName != this.name ||
        this.defaultSurname != this.surname ||
        this.defaultPhone != this.phone
      result = result && this.name.length > 0 && this.surname.length > 0
      return result
    },
    userCredentialsHref(): RawLocation {
      return {
        name: RouteNames.UserCredentials,
      }
    },
  },
  created() {
    const userContact: UserContact | undefined = this.getMe.contacts
    if (userContact === undefined) {
      throw 'userContact == undefined'
    }
    this.initFormDataAndDefaultValues(userContact)
  },
  metaInfo() {
    return { title: this.$tc('settings.personal') }
  },
})
